// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import Draggable from 'react-draggable';
import BASE_URL from "../../../../config/config";
function JobSelectionModal({ show, onClose, jobList, onSelectJob }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const activeDateFormat = useDateFormat();
    const CompanyID = localStorage.getItem("CompanyID");
    const tableRef = useRef();
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                  $('.dt-search input[type="search"]').css('margin-left', '10px');
                  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (jobList.length > 0) {
            initDataTable();
        }
    }, [jobList]);
    const truncateText = (text, maxLength = 10) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
               <Draggable handle=".modal-content" onStart={handleStart}
                cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Job</h5>
                            <button type="button" className="btn-close" onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th className="no-wrap">Job No.</th>
                                            <th className="no-wrap">Customer</th>
                                            <th className="no-wrap">Priority</th>
                                            <th className="no-wrap">Category</th>
                                            <th className="no-wrap">Description</th>
                                            <th className="no-wrap">Due Date</th>
                                            <th className="no-wrap">Date Created</th>
                                            <th className="no-wrap">Assigned To</th>
                                            <th className="no-wrap">Price</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {jobList.map(job => (
                                            <tr key={job.IssueID} onClick={() => onSelectJob(job)} style={{ cursor: 'pointer' }}>
                                                <td className="no-wrap">{truncateText(job.bnt_OrderNumber)}</td>
                                                <td className="no-wrap">{truncateText(job.CompanyName)}</td>
                                                <td className="no-wrap">{job.Icon ? <img style={{ "width": "20px", "height": "20px" }} src={`${BASE_URL}/uploads/${CompanyID}/Setup/Priority/${job.Icon}`} alt="Icon" /> : job.PriorityName}</td>
                                                <td className="no-wrap">{truncateText(job.CategoryName)}</td>
                                                <td className="no-wrap">{truncateText(job.IssueTitle)}</td>
                                                <td className="no-wrap"> {formatDateWithFns(job.TimeToCall, activeDateFormat)}</td>
                                                <td className="no-wrap"> {formatDateWithFns(job.DateCreated, activeDateFormat)}</td>
                                                <td className="no-wrap"> {truncateText(job.AssignedTo)}</td>
                                                <td>{job.Symbol}{job.Prices}</td>
                                                <td className="no-wrap">{job.IsIcon ? <img style={{ "width": "35px", "height": "20px" }} src={`${BASE_URL}/uploads/${CompanyID}/Setup/Status/${job.IsIcon}`} alt="Icon" /> : job.StatusName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default JobSelectionModal;
